import { render, staticRenderFns } from "./RiskEvent.vue?vue&type=template&id=7048bb92&scoped=true"
import script from "./RiskEvent.vue?vue&type=script&lang=js"
export * from "./RiskEvent.vue?vue&type=script&lang=js"
import style0 from "./RiskEvent.vue?vue&type=style&index=0&id=7048bb92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7048bb92",
  null
  
)

export default component.exports